import { all, call } from 'redux-saga/effects';
import { authSagas } from "./auth/auth.sagas";
import { mainSagas } from "./main/main.sagas";
import { canvasSagas } from "./canvas/canvas.sagas";
import { diagramSagas } from "./diagram/diagram.sagas";
import { workspaceSagas } from "./workspace/workspace.sagas";
import { invitationSagas } from "./invitation/invitation.sagas";

export function* rootSaga() {
	yield all([
		call(authSagas),
		call(mainSagas),
		call(canvasSagas),
		call(diagramSagas),
		call(workspaceSagas),
		call(invitationSagas),
	])
}